import { gql } from '@src/lib/gql'

export const DELETE_ADVISOR_AGREEMENT = gql`
  mutation DeleteAdvisorAgreement($input: DeleteAdvisorAgreementInput!) {
    deleteAdvisorAgreement(input: $input) {
      advisorAgreement {
        id
        advisorAgreementId
        statusKey
        deletedAt
      }
    }
  }
`
